import { render, staticRenderFns } from "./AnnounceComp.vue?vue&type=template&id=50c1e5fe&scoped=true&"
import script from "./AnnounceComp.vue?vue&type=script&lang=js&"
export * from "./AnnounceComp.vue?vue&type=script&lang=js&"
import style0 from "./AnnounceComp.vue?vue&type=style&index=0&id=50c1e5fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c1e5fe",
  null
  
)

export default component.exports